export default __webpack_public_path__ + "static/media/widget.ef71188b.svg";